/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Guidevideo_Tab_Watch1Inputs */

const vi_guidevideo_tab_watch1 = /** @type {(inputs: Guidevideo_Tab_Watch1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Xem video`)
};

/**

* @param {Guidevideo_Tab_Watch1Inputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
const guidevideo_tab_watch1 = /** @type {((inputs?: Guidevideo_Tab_Watch1Inputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Guidevideo_Tab_Watch1Inputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_guidevideo_tab_watch1(inputs)
});
export { guidevideo_tab_watch1 as "guideVideo_tab_watch" }